import PropTypes from "prop-types"
import React, {Component} from "react"

import Heading from "../Heading/Heading"


export class AuthHeading extends Component {
  getTitle() {
    const { authState } = this.props
    switch (authState) {
      case "signedIn":
        return "Sign out"
      case "signedOut":
        return "Sign in to Archie"
      case "signUp":
        return "Sign up for Archie"
      case "signedUp":
        return "Sign in to Archie"
      case "confirmSignUp":
        return "Confirm Sign Up"
      case "forgotPassword":
        return "Reset Password"
      default:
        return "Sign in to Archie"
    }
  }

  render() {
    return (
      <Heading level={1} modifiers={["major"]}>{this.getTitle()}</Heading>
    )
  }
}

AuthHeading.propTypes = {
  authState: PropTypes.string
}

export default AuthHeading
